import { ToolGroupEntry } from '../../extensions/tool-extension';
import { DefaultToolCallGroup } from './DefaultToolCallGroup';
import { InlineToolGroup } from './InlineToolGroup';

type ToolCallGroupProps = {
  entries: ToolGroupEntry[];
  variant?: 'default' | 'inline';
};

export const ToolCallGroup = ({
  entries,
  variant = 'default',
}: ToolCallGroupProps) => {
  if (variant === 'inline') {
    return <InlineToolGroup entries={entries} />;
  }

  return <DefaultToolCallGroup entries={entries} />;
};
